/* eslint  no-undef: 0 */
import { backOff } from "exponential-backoff";
import * as _debug from "debug";
const debug = _debug("soilfood:helpers");

export function enableEnterKey(input) {
  /* Store original event listener */
  const _addEventListener = input.addEventListener;

  input.addEventListener = (type, listener) => {
    if (type === "keydown") {
      /* Store existing listener function */
      const _listener = listener;
      listener = (event) => {
        /* Simulate a 'down arrow' keypress if no address has been selected */
        const suggestionSelected =
          document.getElementsByClassName("pac-item-selected").length;
        if (
          (event.key === "Enter" || event.key === "Tab") &&
          !suggestionSelected
        ) {
          const e = new KeyboardEvent("keydown", {
            key: "ArrowDown",
            code: "ArrowDown",
            keyCode: 40,
          });
          _listener.apply(input, [e]);
          input.dispatchEvent(new Event("selected"));
        }
        _listener.apply(input, [event]);
      };
    }
    _addEventListener.apply(input, [type, listener]);
  };
}

export async function retrieveLocation(address = "", location = "") {
  const geocoder = new google.maps.Geocoder();
  let locationResponse;
  if (address === "" && location === "") return false;
  try {
    const geocodeRequest = {
      componentRestrictions: {
        country: "fi",
      },
    };
    if (address !== "") {
      geocodeRequest.address = address;
    } else if (location !== "") {
      geocodeRequest.location = location;
    }
    locationResponse = await geocoder.geocode(geocodeRequest);
  } catch (e) {
    return false;
  }
  if (!locationResponse || !locationResponse.results) {
    return false;
  }
  const placeObject = locationResponse.results[0].address_components.reduce(
    (seed, { long_name, types }) => (
      types.forEach((t) => (seed[t] = long_name)), seed
    ),
    {}
  );

  return {
    placeObject,
    geometryLocation: locationResponse.results[0].geometry.location,
  };
}

export async function getAddressInfo(place, input, fromEvent) {
  let placeObject,
    locationObject = {};
  debug(`getAddressInfo ${place} ${input}`);
  if (place && place.address_components && !fromEvent)
    placeObject = place.address_components.reduce(
      (seed, { long_name, types }) => (
        types.forEach((t) => (seed[t] = long_name)), seed
      ),
      {}
    );
  if (!place || !placeObject || !placeObject.postal_code || fromEvent) {
    let response = await retrieveLocation(input.value); // First based on input
    let savedLocality;
    if (response && response.placeObject.locality)
      savedLocality = response.placeObject.locality;
    if (!response || !response.placeObject.postal_code)
      response = await retrieveLocation("", response.geometryLocation); // If all else fail we try with the actual location

    if (response && response.placeObject.locality)
      savedLocality = response.placeObject.locality;

    if (response && !response.placeObject.postal_code && savedLocality) {
      response = await retrieveLocation(savedLocality); // And if even that fail we try using the locality only.
    }

    locationObject.placeObject = response.placeObject;
    locationObject.geometryLocation = response.geometryLocation;

    debug(locationObject);
  } else if (place && place.geometry?.location) {
    locationObject.placeObject = placeObject;
    locationObject.geometryLocation = place.geometry.location;
  } else if (place) {
    locationObject.placeObject = placeObject;
  }
  return locationObject;
}

export async function retrieveSeller(placeObject) {
  const url =
    process.env.NODE_ENV !== "production"
      ? `https://soilfood.localhost/wp-json/soilfood-location/v1/post_code?post_code=${
          placeObject.postal_code ?? 0
        }&locality=${placeObject.locality ?? "none"}`
      : `/wp-json/soilfood-location/v1/post_code?post_code=${
          placeObject.postal_code ?? 0
        }&locality=${placeObject.locality ?? "none"}`;
  try {
    const response = await fetch(url);
    if (!response.ok) {
      return false;
    }

    const { data } = await response.json();
    return data;
  } catch (e) {
    return false;
  }
}

export async function retrieveSwedishSeller() {
  const url =
    process.env.NODE_ENV !== "production"
      ? `https://soilfood.localhost/wp-json/soilfood-location/v1/swedish-seller`
      : `/wp-json/soilfood-location/v1/swedish-seller`;
  try {
    const response = await fetch(url);
    if (!response.ok) {
      return false;
    }

    const { data } = await response.json();
    return data;
  } catch (e) {
    return false;
  }
}

export async function retrieveTeollisuusSellers() {
  const url =
    process.env.NODE_ENV !== "production"
      ? `https://soilfood.localhost/wp-json/soilfood-location/v1/industry-seller`
      : `/wp-json/soilfood-location/v1/industry-seller`;
  try {
    const response = await fetch(url);
    if (!response.ok) {
      return false;
    }

    const { data } = await response.json();
    return data;
  } catch (e) {
    return false;
  }
}

const names = {
  152: "rakenne",
  153: "maanparannus",
  154: "teho",
  155: "ravinne",
};

/* eslint-disable */
export const createProductObject = (products) => {
  const productsObject = {};
  const extraProducts = {};
  const rakenne20 = products.filter((p) => p.id === 5746);
  if (rakenne20.length > 0) extraProducts["rakenne20"] = rakenne20[0];
  const otherRakenne = products.filter((p) =>
    [5744, 5745, 6808, 7946].includes(p.id)
  );
  if (otherRakenne.length > 0) extraProducts["otherRakenne"] = otherRakenne[0];
  products.forEach((product) => {
    debug(product.tuotekategoria);
    let tuotekategoria = product.tuotekategoria.filter((cat) => {
      debug(cat);
      return [152, 153, 154, 155].includes(cat);
    })[0];
    debug(`cat: ${tuotekategoria}`);
    if (!tuotekategoria) tuotekategoria = "special";
    else tuotekategoria = names[tuotekategoria];
    debug(`productsObject ${tuotekategoria}`);
    debug(`productsObject ${product}`);
    if (!productsObject[tuotekategoria])
      productsObject[tuotekategoria] = product;
  });

  debug(`extraProducts ${extraProducts}`);

  if (
    "otherRakenne" in extraProducts &&
    productsObject["rakenne"].id === extraProducts["otherRakenne"].id &&
    "rakenne20" in extraProducts
  ) {
    productsObject["rakenne-extra"] = extraProducts["rakenne20"];
  }
  debug(`productsObject ${productsObject}`);
  return productsObject;
};

// 38: maanparannus, 39: lannoiteet, 147: kalkit
const structure = {
  38: [148, 149],
  39: [156, 157, 151, 150],
  147: [152, 153, 154, 155],
  34049: [],
};

export const buildCategoryStructure = (categories) => {
  const structuredObject = {};
  categories.forEach((c) => {
    structuredObject[c.name] = c;
    structuredObject[c.id] = c;
  });
  return structuredObject;
};

export const createStructure = (products, filterCategory = false) => {
  const structuredObject = {};
  products.forEach((p) => {
    if (!p._embedded || !p._embedded["wp:term"]) return;
    const parents = Object.keys(structure).map(Number);
    const children = Object.entries(structure).flatMap((e) => e[1]);
    debug(p.slug);
    // Returns an object with the id and the slug.
    let hasParent = false;
    let hasChildren = false;
    let parentKey;
    let parentId;
    let childrenKey;
    let childrenId;
    p._embedded["wp:term"][0].forEach((cat) => {
      if (filterCategory && cat.id === filterCategory) {
        parentKey = cat.name;
        parentId = cat.id;
        hasParent = true;
      } else if (!filterCategory && parents.includes(cat.id)) {
        parentKey = cat.name;
        parentId = cat.id;
        hasParent = true;
      } else if (children.includes(cat.id)) {
        hasChildren = true;
        childrenKey = cat.name;
        childrenId = cat.id;
      }
    });
    if (hasParent && !hasChildren) {
      const hasChild = structure[parentId].length > 0;
      if (!hasChild) {
        hasChildren = true;
        childrenKey = parentKey;
        childrenId = parentId;
      }
    }
    if (!hasParent || !hasChildren) return;
    debug(`createStructure ${parentKey} ${childrenKey}`);
    if (!structuredObject[parentKey]) structuredObject[parentKey] = {};
    if (!structuredObject[parentKey][childrenKey])
      structuredObject[parentKey][childrenKey] = [];
    structuredObject[parentKey][childrenKey].push(p);
  });
  debug(`createStructure ${structuredObject}`);
  console.timeEnd("filterProducts");
  return structuredObject;
};

export const getDirectionDistance = async (locA, locB, distance) => {
  if (isNaN(distance)) {
    return false;
  }

  const latA = typeof locA.lat === "function" ? locA.lat() : locA.lat;
  const lngA = typeof locA.lng === "function" ? locA.lng() : locA.lng;

  const latB = typeof locB.lat === "function" ? locB.lat() : locB.lat;
  const lngB = typeof locB.lng === "function" ? locB.lng() : locB.lng;

  const directionsService = new google.maps.DirectionsService();

  const req = {
    origin: {
      lat: parseFloat(latA),
      lng: parseFloat(lngA),
    },
    destination: {
      lat: parseFloat(latB),
      lng: parseFloat(lngB),
    },
    travelMode: google.maps.TravelMode.DRIVING,
  };

  debug(req);

  try {
    const result = await backOff(() => directionsService.route(req), {
      numOfAttempts: 5,
      startingDelay: 100,
    });
    if (!result.routes && result.routes.length < 1) return false;
    const route = result.routes[0];
    if (!route.legs || route.legs.length < 1) return false;
    const leg = route.legs[0];
    if (!leg.distance) return false;
    if (!leg.distance.value) return false;

    const distInMeters = distance * 1000;
    debug(`Distance: ${leg.distance.value}`, distInMeters);
    if (leg.distance.value <= distInMeters) {
      debug(true);
      return leg.distance.value / 1000;
    }
    return false;
  } catch (_) {
    return false;
  }
};

export const isInRange = (locA, locB, distance) => {
  if (isNaN(distance)) {
    return false;
  }

  const latA = typeof locA.lat === "function" ? locA.lat() : locA.lat;
  const lngA = typeof locA.lng === "function" ? locA.lng() : locA.lng;

  let radlat1 = (Math.PI * latA) / 180;
  let radlat2 = (Math.PI * locB.lat) / 180;
  let theta = lngA - locB.lng;
  let radtheta = (Math.PI * theta) / 180;
  let dist =
    Math.sin(radlat1) * Math.sin(radlat2) +
    Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
  if (dist > 1) {
    dist = 1;
  }
  dist = Math.acos(dist);
  dist = (dist * 180) / Math.PI;
  dist = dist * 60 * 1.1515;
  dist = dist * 1.609344; // to KM

  if (dist <= distance) {
    return dist;
  }
  return false;
};

export const isSameLocation = (add1, add2) => {
  debug(add1, add2);
  if (!add1.lat || !add1.lng) return false;
  if (!add2.lat || !add2.lng) return false;

  const lat1 = typeof add1.lat === "function" ? add1.lat() : add1.lat;
  const lng1 = typeof add1.lng === "function" ? add1.lng() : add1.lng;

  const lat2 = typeof add2.lat === "function" ? add2.lat() : add2.lat;
  const lng2 = typeof add2.lng === "function" ? add2.lng() : add2.lng;

  return lat1 === lat2 && lng1 === lng2;
};

export const getCurrentLocale = () => {
  return window.vueSettings?.locale ?? "fi";
};

export function imageSourceFromProduct(product) {
  if (
    product._embedded["wp:featuredmedia"] &&
    product._embedded["wp:featuredmedia"][0]?.media_details?.sizes &&
    Object.keys(product._embedded["wp:featuredmedia"][0]?.media_details?.sizes)
      .length > 0
  ) {
    for (const [size, values] of Object.entries(
      product._embedded["wp:featuredmedia"][0]?.media_details?.sizes
    )) {
      if (values.source_url) {
        debug(size);
        return values.source_url;
      }
    }
  }
  if (
    product._embedded["wp:featuredmedia"] &&
    product._embedded["wp:featuredmedia"][0]?.source_url
  )
    return product._embedded["wp:featuredmedia"][0]?.source_url;
  return "";
}
